import { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import { defaultInjuredFormikValues } from "src/storage";
import {
  DataEntryAccidentStepSectionProps,
  FormikInjured,
  YesNoAnswer,
} from "src/types";
import { useYesNoAnswer } from "src/utils";

export const useDataEntryAccidentStepInjured = ({
  formikAccidentValues,
  formik,
}: DataEntryAccidentStepSectionProps) => {
  const { t } = useTranslation();
  const { yesNoOptions } = useYesNoAnswer();

  const { setFieldError, setFieldTouched, setFieldValue } = formik;

  const onAddInjuredClick = () => {
    const currentInjuredList =
      formikAccidentValues.injuredsInfo.injuredList || [];

    if (setFieldValue)
      setFieldValue("accidentData.injuredsInfo.injuredList", [
        ...currentInjuredList,
        { ...defaultInjuredFormikValues },
      ]);
  };

  const onRemoveInjuredClick = () => {
    const currentInjuredList =
      formikAccidentValues.injuredsInfo.injuredList || [];

    if (currentInjuredList.length === 0) return;

    setFieldValue("accidentData.injuredsInfo.injuredList", [
      ...currentInjuredList.slice(0, -1),
    ]);
  };

  const onSelectInjuredQuestion = (event: ChangeEvent<HTMLInputElement>) => {
    const injuredFCQuestion = event.target.value;
    if (!injuredFCQuestion) return;

    const newValue: FormikInjured[] = [];
    if (injuredFCQuestion === YesNoAnswer.YES) {
      newValue.push({ ...defaultInjuredFormikValues });
    }
    setFieldValue("accidentData.injuredsInfo.injuredList", newValue);
    setFieldError("accidentData.injuredsInfo.injuredList", "");
    setFieldTouched("accidentData.injuredsInfo.injuredList", false, false);
  };

  const removeInjuredButtonVisible =
    formikAccidentValues.injuredsInfo?.injuredList.length > 0;

  const injuredsListVisible =
    formikAccidentValues.injuredsInfo?.injuredQuestion === YesNoAnswer.YES;

  return {
    yesNoOptions,
    removeInjuredButtonVisible,
    injuredsListVisible,
    t,
    onAddInjuredClick,
    onRemoveInjuredClick,
    onSelectInjuredQuestion,
  };
};
